import { Component, HostListener, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DOCUMENT } from "@angular/platform-browser";
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { o7NodeService } from '@07/node-resource';
import { o7SEOService } from '../../shared/services/o7SEO';
import { o7EventService } from '@07/utils';
import { Fylke } from '../types';

@Component({
  styles: [require('./styles.scss')],
  template: require('./template.html')
})
export class FylkePage implements AfterViewInit {
    background: any;
    node: Fylke;
    url: string;
    children: any[];
    loading: number;
    results: any[];
    total: number;
    max: number;
    perPage: number;
    curP: number;
    group_background: any;
    @ViewChild('backdrop') el:ElementRef;

    constructor(@Inject(DOCUMENT) private document: Document, private route: ActivatedRoute, private router: Router, private nodeService: o7NodeService, private sanitizer: DomSanitizer, private seoService: o7SEOService, private events: o7EventService) {
        this.children = [];
        this.results = [];
        this.perPage = 9;
        this.curP = 1;
        this.max = 0;
        this.loading = 0;
        this.events.emit('loading-toggle', 1);
        this.route.params.subscribe(params => {
            this.url = params['fylke'];
            this.nodeService.getNodeBySlug$('fylker/'+this.url).subscribe((node: Fylke) => {
                if (node && node._entitytype !== 'error') {
                    this.node = node;

                    let url = 'http://lorempixel.com/g/1160/655/food?' + Date.now();
                    if (node.background_image) {
                        url = node.background_image.src;
                    }
                    this.background = this.sanitizer.bypassSecurityTrustStyle(`linear-gradient(180deg, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), url(${url})`);

                    if(node.group_image) {
                        let link = node.background_image.getStyle('landscape');
                        this.group_background = this.sanitizer.bypassSecurityTrustStyle(`linear-gradient(180deg, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), url(${link})`);
                    }
                    
                    if (node.children) {
                        this.results = [];
                        this.children = node.children;
                        this.page(1);
                    }
                    this.seoService.update(this.node);
                } else {
                    this.router.navigate(['/404']);
                }
                this.events.emit('loading-toggle', 0);
            }, error => {
                this.router.navigate(['/404']);
                this.events.emit('loading-toggle', 0);
            });
        });
    }

    ngAfterViewInit() {
        this.el.nativeElement.style.backgroundImage = `url(/assets/fylker/${this.url}.png)`
        this.el.nativeElement.style.backgroundPosition = `center calc(50% + 40px)`
    }

    @HostListener("window:scroll", [])
    onWindowScroll() {
         if (typeof window !== 'undefined') {
            if (window.scrollY > 1028) return;
            if (window.scrollY > 5) {
                let pixels = 40 + (window.scrollY / 4)
                this.el.nativeElement.style.backgroundImage = `url(/assets/fylker/${this.url}.png)`
                this.el.nativeElement.style.backgroundPosition = `center calc(50% + ${pixels}px)`
            } else {
                this.el.nativeElement.style.backgroundImage = `url(/assets/fylker/${this.url}.png)`
                this.el.nativeElement.style.backgroundPosition = `center calc(50% + 40px)`
            }
        }
        
    }

    page(_pnum) {
        
        this.curP = _pnum;
        this.max = this.curP*this.perPage;
        let start = (this.curP-1)*this.perPage;
        this.total = this.children.length;
        this.max = this.max >= this.total ? this.total : this.max;
        for (let i=start; i<this.max; i++) {
            this.loading++;
            this.nodeService.loadById$(this.children[i]).subscribe(node => {
                if (node) this.results[i] = node;
                this.loading--;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+fylker/fylke/index.ts